module.exports = __webpack_public_path__ + "static/media/sinkFlooded.3ce5c951.png";